export default "__VITE_ASSET__2a9e263b__"